/**
 * Default configurations (by style) for toastr
 */
const TOAST_OPTIONS = {

  'default': {
    'closeButton': true,
    'newestOnTop': false,
    'positionClass': 'toast-bottom-right',
    'preventDuplicates': true,
    'timeOut': 2500
  },

  error: {
    'timeOut': 0,
    'extendedTimeOut': 0
  }
};

export class Toast {

  static getDefaultConfig(style, options) {
    return $.extend(true, {},
      TOAST_OPTIONS['default'],
      TOAST_OPTIONS[style] || {},
      options
    );
  }

  static show(style, content, title, options) {

    if (typeof title !== 'string') {
      options = title;
      title = null;
    }
    if (typeof toastr[style] !== 'function') { // eslint-disable-line no-undef
      return;
    }

    toastr[style](content, title, Toast.getDefaultConfig(style, options)); // eslint-disable-line no-undef
  }

  static success(...args) {
    Toast.show.apply(null, ['success', ...args]);
  }
  static error(...args) {
    Toast.show.apply(null, ['error', ...args]);
  }
  static warning(...args) {
    Toast.show.apply(null, ['warning', ...args]);
  }
  static info(...args) {
    Toast.show.apply(null, ['info', ...args]);
  }
}